import {
    CANCEL_RESERVATION,
    RESERVE_DOMAIN,
    SET_DOMAINS_FOR_USER
} from '../actions/domainsActions';

const initialState = []

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_DOMAINS_FOR_USER: return onSetDomainsForUser(state, action);
        case RESERVE_DOMAIN: return onReserveDomain(state, action);
        case CANCEL_RESERVATION: return onCancelReservation(state, action);
        default:
            return state;
    }
}

const onReserveDomain = (state, action) => {
    console.log(action);
    let domains = state.filter(() => true);
    domains.push(action.domain);
    return domains;
}

const onCancelReservation = (state, action) => {
    console.log(action);
    const news = state.filter((domain) => domain.domain !== action.domain.domain);
    console.log(news);
    return news
}
const onSetDomainsForUser = (state, action) => {
    console.log(action);
    return [...action.domains];
}
